'use strict';

module.exports = ['$scope', function ($scope) {


        $scope.mapModuleText = 'gMapIndex';

// ***********************************************
// MARKERS
// ***********************************************
        $scope.markers = [];
        $scope.markers = [
            {idevent: "2", lat: "40.11", lon: "-75.21", icon: "roadworks", description: "descrizione dell'evento 2"},
            {idevent: "3", lat: "40.22", lon: "-75.10", icon: "roadworks", description: "descrizione dell'evento 3"},
            {idevent: "4", lat: "40.33", lon: "-74.10", icon: "accident", description: "descrizione dell'evento 4"}
        ];


// ***********************************************
// DIRECTIONS
// ***********************************************
        // $scope.directions = {};
        $scope.directions =
                {
                    idevent: "6",
                    icon: "roadworsks",
                    showPanel: false,
                    panelName: "P2",
                    travelMode: "",
                    originLat : "40.22",
                    originLng : "-75.21",
                    //origin: "[40.22, -75.21]",
                    destinationLat: "40.66",
                    destinationLng: "-74.66",
                    //destination: "[40.66, -74.66]",
                    wayPoints: [
                    ]
                }


// ***********************************************
// SHAPES
// ***********************************************
        $scope.shapes = [];

        // POLIGONO
        var triangleCoords = [
            {lat: 25.774, lng: -80.190},
            {lat: 18.466, lng: -66.118},
            {lat: 32.321, lng: -64.757},
            {lat: 25.774, lng: -80.190}
        ];

        // RETTANGOLO
        var bounds = {
            north: 33.685,
            south: 30.671,
            east: -85.234,
            west: -100.251
        };

        $scope.shapes = [
            // POLIGONO
            {
                shapeType: 'polygon',
                vertex: triangleCoords
            },

            // RETTANGOLO
            {
                shapeType: 'rectangle',
                vertex: bounds
            }
        ];

        $scope.directiveTest = function () {

        };

        $scope.mapShapes = function (shapes) {
            console.log('PARENT $scope.mapShapes', shapes);
        };

        $scope.mapDirections = function (route, waypoint) {
            console.log('PARENT $scope.mapDirections', route, waypoint);
        };

        $scope.mapMarkers = function (markers) {
            console.log('PARENT $scope.mapMarkers', markers);
        };

        $scope.mapMarkerOpenEvent = function (marker) {
            console.log('PARENT $scope.mapMarkerOpenEvent');
        };

        $scope.mapBoundChangeEvent = function (mapbounds) {
            console.log('PARENT $scope.mapBoundChangeEvent');
        };


    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/components/index/indexCtrl.js
// module id = 325
// module chunks = 0